<nz-spin [nzTip]="loggingTip" class="bg-slate-50">
  <div class="home-carousel-container">
    <nz-carousel nzAutoPlay *ngIf="carouselList && carouselList?.length">
      <div 
        nz-carousel-content 
        *ngFor="let item of carouselList">
        <div class="flex justify-center">
          <img [src]="item.imageBase64" [ngStyle]="carouselImageWH" />
        </div>
      </div>
    </nz-carousel>
    <nz-empty *ngIf="carouselList?.length === 0" [nzNotFoundContent]="null"></nz-empty>
  </div>
</nz-spin>

